import { TENANT_HEADER_NAME } from "@sg-protect/core";
import { scopeQueryKeyToTenant, unscopedQueryOptions, useQuery } from "../client.ts";

interface UseGetTenantInfoQueryOptions {
    enabled?: boolean;
}

export function useGetTenantInfoQuery(options: UseGetTenantInfoQueryOptions = {}) {
    return useQuery("get", "/bff/tenant/getInfo", undefined, { ...options });
}

export function tenantInfoQueryOptions(tenantId: string) {
    const base = unscopedQueryOptions("get", "/bff/tenant/getInfo", { headers: { [TENANT_HEADER_NAME]: tenantId } });

    return scopeQueryKeyToTenant(base, tenantId);
}
